import { render } from "./TableRow.vue?vue&type=template&id=1f58a8a1"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script